<!-- 问题反馈 -->
<template>
    <div>
        <Panel title="系统代码查询">
            <template slot="buttons">
                <el-button title="查询" class="blue" @click="pageTable.handleLoad()" icon="el-icon-fa-search">查询</el-button>
                <el-button title="重置" class="yellow" @click="pageTable.handleReset()" icon="el-icon-fa-refresh">重置</el-button>
            </template>

            <el-form ref="queryForm">
                <el-row>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item prop="quester" label="代码标识">
                            <el-input v-model="pageTable.param.sc_code"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item prop="quester" label="代码描述">
                            <el-input v-model="pageTable.param.sc_name"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </Panel>

        <Panel title="系统代码列表">
            <template slot="buttons">
                <el-button title="添加" class="green" icon="el-icon-fa-plus" @click="doAdd">添加</el-button>
                <el-button title="删除" class="red" icon="el-icon-fa-trash" @click="doSeleDel">删除</el-button>
            </template>

            <el-table highlight-current-row stripe border :data="pageTable.data" v-loading="pageTable.isLoading"
                      ref="table" @selection-change="handleSelectionChange" element-loading-spinner="el-icon-loading"
                      element-loading-text="数据加载中" height="calc(100vh - 280px)">
                <el-table-column prop="$rownum" label="NO." width="50" align="center"/>
                <el-table-column type="selection" align='center' width="50"></el-table-column>
                <el-table-column prop="sccode" label="代码标识" min-width="15"></el-table-column>
                <el-table-column prop="scname" label="代码描述" min-width="15" show-overflow-tooltip></el-table-column>
                <el-table-column prop="sckey" label="代码名称" min-width="15"></el-table-column>
                <el-table-column prop="scvalue" label="代码值" min-width="15"></el-table-column>
                <el-table-column prop="scorder" label="代码顺序" min-width="15"></el-table-column>
                <el-table-column prop="scstatus" dict='scstatus' show-overflow-tooltip label="有效性" min-width="15">
                    <template slot-scope="scope">
                        <SysCode :type="'scstatus'" :value="scope.row.scstatus"></SysCode>
                    </template>
                </el-table-column>
                <el-table-column prop="opcomment" label="备注" min-width="15"></el-table-column>
                <el-table-column label="操作" width="150" align="center">
                    <template slot-scope="scope">
                        <el-button title="编辑" class="blue" @click="doEdit(scope.$index, scope.row)" icon="el-icon-fa-edit">编辑</el-button>
                        <el-button title="删除" class="red" @click="doDelete( scope.$index, scope.row)" icon="el-icon-fa-trash">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <export-ctrl class="pull-left" @export="pageTable.handleExport($event, $refs.table)"/>
            <el-pagination background :page-size.sync="pageTable.size" :current-page.sync="pageTable.curr" :total="pageTable.total"/>
        </Panel>

        <el-dialog close-on-press-escape append-to-body v-draggable :visible.sync="editor.show" title="系统代码编辑" width="40%">
            <div class="dialog-button">
                <el-button title="保存" class="blue" icon="el-icon-fa-save" @click="refsaveSysCode()">保存</el-button>
            </div>
            <div v-if="editor.show">
                <SysCodeEdit v-if="editor.show" ref="edit" :dat='postdat'
                             @upd='()=>{editor.show = false; pageTable.handleLoad()}'></SysCodeEdit>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import SysCodeEdit from "./SysCodeEdit";
    import SysCodeApi from "./SysCode";
    import {PageTable} from 'cnetong-core-frontend';

    export default {
        components: {SysCodeEdit},
        data() {
            return {
                pageTable: new PageTable({
                    autoLoad: true,
                    doLoad: SysCodeApi.querySysCodeList
                }),
                postdat: {},
                editor: {
                    show: false,
                    loading: false
                },
                multipleSelection: []
            };
        },
        mounted() {
            this.queryData();
        },
        methods: {
            // 打开编辑页面
            async refsaveSysCode() {
                await this.confirm();
                this.$refs.edit.saveSysCode();
            },
            doEdit(index, rowData) {
                this.loading = true;
                this.postdat = rowData;
                this.editor.show = true;
                this.loading = false;
            },
            doAdd() {
                this.loading = true;
                this.postdat = {};
                this.editor.show = true;
                this.loading = false;
            },
            async doDelete(index, rowData) {
                try {
                    await this.confirm();
                    this.pageTable.isLoading = true;
                    await SysCodeApi.delSysCode([rowData.uuid]);
                    this.pageTable.handleLoad();
                } finally {
                    this.pageTable.isLoading = false;
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            async doSeleDel() {
                if (this.multipleSelection.length === 0) {
                    this.$message.warning("请选择数据！");
                    return;
                }
                try {
                    this.confirm();
                    this.pageTable.isLoading = true;
                    let array = this.multipleSelection.map(v => v.uuid);
                    await SysCodeApi.delSysCode(array);
                    this.pageTable.handleLoad();
                } finally {
                    this.pageTable.isLoading = false;
                }
            }
        }
    };
</script>
